import React, { useState } from "react";
import { Box, Typography } from "@mui/material";
import { DateField, TimeField } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import dayjs from "dayjs";

interface DatePickerProps {
  initialValue?: string;
  onChanged?: (newValue: string) => void;
}

const DatePicker = ({
  initialValue = '',
  onChanged,
}: DatePickerProps) => {
  const [value, setValue] = useState(dayjs(initialValue));

  const handleValueChange = (newValue: any) => {
    setValue(newValue);
    onChanged?.(newValue);
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Box
        sx={{
          display: "flex",
          flex: 1,
        }}
      >
        <DateField
          value={value}
          format="DD.MM.YY"
          onChange={handleValueChange}
          sx={{
            width: "100%",
            borderRadius: "6px",
            border: "none",

            "& .MuiInputBase-input": {
              height: "46px",
              padding: "0px",
              fontSize: "14px",
              color: value ? "#080808" : "#676767",
              borderRadius: "6px",
              border: "none",
            },

            "&:hover": {
              boxShadow: "none",
            },
            [`& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline,
             & .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline,
             & .MuiOutlinedInput-notchedOutline`]: {
              border: "none",
              borderRadius: "6px",
              boxShadow: "none",
            },
          }}
        />
      </Box>
    </LocalizationProvider>
  );
};

interface DefaultDateInputProps {
  label: string;
  initialValue?: string;
  onChanged?: (newValue: string) => void;
}

export const DefaultDateInput = ({ label, onChanged, initialValue}: DefaultDateInputProps) => {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        flex: 1,
        border: "1px solid #D6D6DB",
        borderTop: "none",

        "&:first-of-type": {
          borderTop: "1px solid #D6D6DB",
          borderTopLeftRadius: "6px",
          borderTopRightRadius: "6px",

          "&>.leftBlock": {
            borderTopLeftRadius: "6px",
          },
        },
        "&:last-child, &:last-child>.leftBlock": {
          borderBottomLeftRadius: "6px",
        },
      }}
    >
      <Box
        className="leftBlock"
        sx={{
          display: "flex",
          alignItems: "center",
          height: "46px",
          minWidth: 170,
          paddingLeft: "16px",
          backgroundColor: "#F3F3F3",
          color: "#1F1F1F",
          borderRight: "none",
        }}
      >
        <Typography
          sx={{
            fontWeight: "500",
            fontSize: "14px",
            cursor: "default",
          }}
        >
          {label}
        </Typography>
      </Box>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          padding: "0px 16px",
          flex: 1,
        }}
      >
        <DatePicker
          initialValue={initialValue}
          onChanged={onChanged}
        />
      </Box>
    </Box>
  );
};
